// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Coupons from '../components/Coupons';
import {actions as CouponsAction} from '../duck';

import type {RootState} from '../../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    coupons: state.coupons.coupons,
    isFetchingCoupons: state.coupons.isFetchingCoupons,
    error: state.coupons.error,
    selectedState: state.coupons.selectedState,
    currency: state.currency.currency,
    store: state.store.store,
    createCouponSuccess: state.coupons.createCouponSuccess,
    updateCouponSuccess: state.coupons.updateCouponSuccess,
    information: state.ui.storeInformation,
  }),
  (dispatch: Dispatch<any>) => bindActionCreators({...CouponsAction}, dispatch)
)(Coupons);
